import Vue from 'vue'
import { INPUT_HANDLER } from './handler'

/**
 * 绑定事件
 * @param {*} el HTML元素
 * @param {String} eventName 事件类型
 * @param {Function} handler 处理方法
 * @param {Object} binding 指令配置信息
 */
const bindEvent = (el, eventName, handler, binding) => {
  const elements = getElements(el)
  for (let i = 0, len = elements.length; i < len; i++) {
    const item = elements[i]
    // 避免因中文输入法导致的双向绑定失效问题，composing状态标识正在输入中文
    item.addEventListener('compositionstart', (e) => {
      e.target.composing = true
    })
    item.addEventListener('compositionend', (e) => {
      e.target.composing = false
    })
    item.addEventListener(eventName, (e) => {
      if (!e.target.composing) {
        handler(e, binding)
      }
    })
  }
}

/**
 * 解除事件
 * @param {*} el HTML元素
 * @param {*} eventName 事件类型
 * @param {*} handler 处理方法
 */
const unBindEvent = (el, eventName, handler) => {
  const elements = getElements(el)
  for (let i = 0, len = elements.length; i < len; i++) {
    const item = elements[i]
    item.removeEventListener(eventName, handler)
  }
}

/**
 * 获取元素，兼容input和el-input
 * @param {*} el HTML元素
 * @returns 元素数组
 */
const getElements = (el) => {
  if (el.nodeName === 'input' || el.nodeName === 'INPUT') {
    return [el]
  } else {
    return el.getElementsByTagName('input')
  }
}

// 声明自定义指令
Vue.directive('number', {
  bind: (el, binding) => {
    const type = binding.arg
    if (!type || !INPUT_HANDLER[type]) return
    for (const eventName in INPUT_HANDLER[type]) {
      if (Object.prototype.hasOwnProperty.call(INPUT_HANDLER[type], eventName)) {
        bindEvent(el, eventName, INPUT_HANDLER[type][eventName], binding)
      }
    }
  },
  unbind: (el, binding) => {
    const type = binding.arg
    if (!type || !INPUT_HANDLER[type]) return
    for (const eventName in INPUT_HANDLER[type]) {
      if (Object.prototype.hasOwnProperty.call(INPUT_HANDLER[type], eventName)) {
        unBindEvent(el, eventName, INPUT_HANDLER[type][eventName])
      }
    }
  },
})
